export default __webpack_public_path__ + "static/media/uploader-abbottLite-3.355dd02f.png";